import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const api = createApi({
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_BASE_URL }),
  reducerPath: "adminApi",
  tagTypes: [
    "User",
    "Products",
    "Customers",
    "Transactions",
    "Deals",
    "Admins",
    "Performance",
  ],
  endpoints: (build) => ({
    getUser: build.query({
      query: (email) => `general/user/${email}`,
      providesTags: ["User"],
    }),
    updateUser: build.mutation({
      query: ({ email, name, phoneNumber }) => ({
        url: `general/settings/${email}`,
        method: 'POST',
        body: { name, phoneNumber },
      }),
      providesTags: ["User"],
    }),
    getDeals: build.query({
      query: ({ page, pageSize, sort, search }) => ({
        url: "management/deals",
        method: "GET",
        params: { page, pageSize, sort, search },
      }),
      providesTags: ["Transactions"],
    }),
    getAllDeals: build.query({
      query: (id) => ({
        url: `sales/deals`,
        method: "GET",
        params: { id },
      }),
      providesTags: ["Transactions"],
    }),
    getAllActivities: build.query({
      query: (id) => ({
        url: `sales/activities`,
        method: "GET",
        params: { id },
      }),
      providesTags: ["Transactions"],
    }),
    getAllContacts: build.query({
      query: (id) => ({
        url: `sales/contacts`,
        method: "GET",
        params: { id },
      }),
      providesTags: ["Customers"],
    }),
    getAllCompanies: build.query({
      query: (id) => ({
        url: `sales/companies`,
        method: "GET",
        params: { id },
      }),
      providesTags: ["Customers"],
    }),
    searchContacts: build.query({
      query: ({ page, pageSize, sort, search }) => ({
        url: "client/contacts",
        method: "GET",
        params: { page, pageSize, sort, search },
      }),
      providesTags: ["Contacts"],
    }),
    registerUser: build.mutation({
      query: (newUser) => ({
        url: "/general/register",
        method: "POST",
        body: newUser,
      }),
    }),
    loginUser: build.mutation({
      query: (user) => ({
        url: "general/login",
        method: "POST",
        body: user,
      }),
    }),
    uploadUserPFP: build.mutation({
      query: ({ email, file }) => {
        const formData = new FormData();
        formData.append('email', email);
        formData.append('profilePic', file);
        return {
          url: `general/profilePic`,
          method: 'POST',
          body: formData,
          headers: { 'Content-Type': undefined },
        };
      },
      invalidatesTags: ['User'],
    }),
    searchDeals: build.query({
      query: (searchTerm) => ({
        url: 'management/search',
        method: 'GET',
        params: { term: searchTerm },
      }),
      providesTags: ['Deals'],
    }),
  }),
});


export const {
  useGetUserQuery,
  useUpdateUserMutation,
  useGetDealsQuery,
  useGetAllContactsQuery,
  useGetAllCompaniesQuery,
  useGetAllActivitiesQuery,
  useSearchContactsQuery,
  useRegisterUserMutation,
  useLoginUserMutation,
  useUploadUserPFPMutation,
  useGetAllDealsQuery,
  useSearchDealsQuery
} = api;
